import { onlyNumbers, isValidCPF, isValidCNPJ, formatCPF, formatCNPJ } from '@brazilian-utils/brazilian-utils';

class Document {
  constructor(value) {
    this.value = value;
  }
  static build(value) {
    return new Document(onlyNumbers(value));
  }
  isValidCPF() {
    return this.value.length === 11 && isValidCPF(this.value);
  }
  isValidCNPJ() {
    return this.value.length === 14 && isValidCNPJ(this.value);
  }
  getValueCPF() {
    if (this.isValidCPF()) {
      return formatCPF(this.value);
    }
    return this.value;
  }
  getValueCNPJ() {
    if (this.isValidCNPJ()) {
      return formatCNPJ(this.value);
    }
    return this.value;
  }
}

export { Document };
